export default {"src":"https://launchpad-static.magicsquare.io/_next/static/media/pacman.1f103710.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};